<template>
  <div>
    <p class="notification_label">You've got a new communication for lead that has been in follow up</p>
    <button-link @click="goToLead">{{ notification.data.record_address }}</button-link>
  </div>
</template>

<script>
import router from "../../../router";
import api from "../../../api";
import dates from "../../../services/dates";

export default {
  name: "InboundFollowUpNotification",
  props: {
    notification: Object
  },
  methods: {
    goToLead() {
      api.notifications.markRead({ notification_id: this.notification.id }).then(() => {
        // NOTE: The database read_at will be different from now, but read_at just needs a date
        // in order for this to work. We don't show the read at time.
        this.notification.read_at = dates.getNowISO()
      });
      router.replace({query: {lead: this.notification.data.record_id}});
    },
  },
}
</script>

<style lang="scss" scoped>
.notification_label {
  margin-bottom: 2px;
  font-size: 0.875rem;
}
</style>
